

/* eslint-disable no-async-promise-executor */
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { environment } from '../../environments/environment';
import { common } from '../_helper/pwa-callback';

export function initializeKeycloak(keycloak: KeycloakService): () => Promise<any> {
  return (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const {tokens,clientId} = await common.getUserProfile();
        await keycloak.init({
          config: {
            url: environment.keycloak.issuer,
            realm: environment.keycloak.realm,
            clientId: clientId || environment.keycloak.clientId,
          },
          loadUserProfileAtStartUp: false,
          initOptions: {
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: window.location.origin + '/assets/verify-sso.html',
            flow: 'standard',
            pkceMethod: 'S256',
            checkLoginIframe: false,
            scope: 'openid profile email phone',
            dpopEnabled: true,
            encryptionEnabled: environment.enableEncryption,
            ...(tokens),
          },
          enableBearerInterceptor: true,
          bearerPrefix: 'DPoP',
          bearerExcludedUrls: ['/assets', '/public', '/cdn.lokos.in', '/signer'],
        });

        keycloak.keycloakEvents$.subscribe((event: any) => {
          if (event && event.type === 6) {
            keycloak.updateToken(30).then((refreshed) => {
              if (refreshed) {
                console.log('Token refreshed successfully');
              } else {
                console.error('Token refresh failed');
              }
            })
              .catch((error) => {
                console.error('Error during token refresh:', error);
              });
          }
        });
        resolve(keycloak);
      } catch (error) {
        reject(error);
      }
    });
  };
}
